export default { 
    data: function() {
        return {
        }
    },
    methods: {
        getThumbImageSrc: function(src) {
            return process.env.VUE_APP_FILE + "320_" + src;
        },
        getThumbImageSrcList: function(res) {
            let imgArray = [];
            if (res) {
                imgArray = res.split(',');
                for (let i = 0; i < imgArray.length; i++) {
                    imgArray[i] = process.env.VUE_APP_FILE + "320_" + imgArray[i];
                }
            }
            return imgArray;
        },
        getImageSrc: function(src) {
            return process.env.VUE_APP_FILE + src;
        },
        getImageArrayByArr: function(srcArr) {
            let arr = [];
            for (let i = 0; i < srcArr.length; i++) {
                arr.push(process.env.VUE_APP_FILE + srcArr[i]);
            }
            return arr;
        },
        getImageArrayByArrIndex: function(srcArr, index) {
            let arr = [];
            for (let i = index; i < srcArr.length; i++) {
                arr.push(process.env.VUE_APP_FILE + srcArr[i]);
            }
            for (let i = 0; i < index; i++) {
                arr.push(process.env.VUE_APP_FILE + srcArr[i]);
            }
            return arr;
        },
        getFirstImageSrc: function(src) {
            if (src) {
                return process.env.VUE_APP_FILE + "320_" + src.split(",")[0];
            }
        },
        getImageSrcList: function(res) {
            let imgArray = [];
            if (res) {
                imgArray = res.split(',');
                for (let i = 0; i < imgArray.length; i++) {
                    imgArray[i] = process.env.VUE_APP_FILE + imgArray[i];
                }
            }
            return imgArray;
        },
        getImageCount: function(src) {
            let count = 0;
            if (src) {
                count = src.split(",").length;
            }
            return count;
        },
        getImageArray: function(src) {
            let array = 0;
            if (src) {
                array = src.split(",");
            }
            return array;
        }
    }
}